import {
  SortDirection,
  UsersSortBy,
  UserStatusValue,
} from 'src/apis/organisation-service/types';
import * as pp from 'src/utils/page-params';

export function usePageParams() {
  return pp.usePageParams(
    pp
      .configure()
      .add(pp.start('start'))
      .add(pp.number('pageSize').default(20))
      .add(pp.param('sortBy').default<UsersSortBy>('EMAIL'))
      .add(pp.param('sortDirection').default<SortDirection>('asc'))
      .add(
        pp.list('status').cast<UserStatusValue>().filter({ label: 'Status' })
      )
      .add(pp.param('role').filter({ label: 'Role' }))
      .add(pp.param('name').filter({ label: 'Name' }))
      .add(pp.param('email').filter({ label: 'Email' }))
  );
}

export type PageParams = ReturnType<typeof usePageParams>;
